import { examinationTypeServices } from '@/services/db'

const state = {
  examinationTypes: [],
  examinationTypesListFormat: []
}

// getters
const getters = {
  getExaminationTypes: state => state.examinationTypes,
  getExaminationTypesListFormat: state => state.examinationTypesListFormat,
}

// actions
const actions = {

  async fetchExaminationTypes ({commit}, payload) {
    try {
      commit('setLoading', true, { root: true })

      const res = await examinationTypeServices.fetchExaminationTypes(payload)
      const list = []
      res.forEach((v,i) => {
        list.push({text:v.examination_type,value:v.id})  
      })
    
      commit('setExaminationTypesListFormat', list)

      commit('setExaminationTypes', res)
      commit('setLoading', false, { root: true })
    } catch (e) {
      console.log(e)
    }
  },

  async updateColumnById ({commit}, payload) {
    /*************************************
    * ID: examinationType Id                      *
    * field: the field that changed      *
    * value: the new value of that field *
    *************************************/
    
    try {
      commit('setLoading', true, { root: true })

      /* API call here to save data to server */
      /* code here */

      const res = await examinationTypeServices.updateExaminationTypeColumn(payload)

      commit('setLoading', false, { root: true })
    } catch (e) { 
      console.log(e)
    }
  },

  async addExaminationType ({commit}) {
    try {
      commit('setLoading', true, { root: true })

      /* API call here to server to create new examinationType */
      /* code here */

      let obj = {
        name: 'New ExaminationType'
      }

      const res = await examinationTypeServices.addExaminationType(obj)
      const data = await Promise.resolve([
        ...state.examinationTypes,
        res.data
      ])


      commit('setExaminationTypes', data)
      commit('setLoading', false, { root: true })
    } catch (e) { 
      console.log(e)
    }
  },
  async sortExaminationType({commit}, payload){
    commit('setLoading', true, { root: true })
    let title = payload.title;
    let order = payload.order

    let data = []
    if (order){
      data= state.examinationTypes.sort((a,b) => a[title].toString().localeCompare(b[title].toString()))
    }else{
      data= state.examinationTypes.sort((b,a) => a[title].toString().localeCompare(b[title].toString()))
    }
    commit('setExaminationTypes', data)
    commit('setLoading', false, { root: true })
  }

}

// mutations
const mutations = {
  resetExaminationTypes (state) {
    state.examinationTypes = []
  },

  setExaminationTypes (state, payload) {
    state.examinationTypes = payload
  },

  setExaminationTypesListFormat (state, payload) {
    state.examinationTypesListFormat = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}